<template>
    <q-select outlined :model-value="numericValue" :label="label" @update:model-value="$emit('update:modelValue', $event)"
        :options="options" :error="error" :loading="loading" hide-bottom-space map-options emit-value>
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
        <template v-slot:error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
    </q-select>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
    modelValue: { type: [String, Number, Object], default: 1 },
    errors: [String, Array],
    label: {
        type: String,
        default: 'Tipo de Venta',
    },
    tipo: [String],
});
defineEmits(['update:modelValue']);
const options = ref([
    { label: 'Producción', value: 1 },
    { label: 'Segunda', value: 3 },
    { label: 'Venta Mostrador', value: 4 },
]);
const numericValue = computed(() => props.modelValue !== null && props.modelValue !== undefined ? Number(props.modelValue) : null);
const error = computed(() => props?.errors && props?.errors?.length !== 0);
const loading = ref(false);
</script>
